import { User } from "./../utils/types";
import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import Cookies from "js-cookie";
import { domainName } from "../utils/constants";

const storedUserInfoString = Cookies.get("jellosite-user");
const storedAccessToken = Cookies.get("jellosite-authToken");
const storedUserInfo = storedUserInfoString
  ? JSON.parse(storedUserInfoString)
  : null;

interface AuthState {
  user: User | null;
  token: string | null;
  isAuthenticated: boolean;
}

const initialState: AuthState = {
  user: storedUserInfo || null,
  token: storedAccessToken || null,
  isAuthenticated: !!storedAccessToken,
};

const authSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    setCredentials: (
      state,
      action: PayloadAction<{ user: User; token: string }>
    ) => {
      const { user, token } = action.payload;
      state.user = user;
      state.token = token;
      state.isAuthenticated = true;
      Cookies.set("jellosite-authToken", token, {
        domain: `.${domainName}`,
      });
      Cookies.set("jellosite-authToken", token, {
        domain: `.${import.meta.env.VITE_STORE_DOMAIN_NAME}`,
      });
      Cookies.set("jellosite-user", JSON.stringify(user || null), {
        domain: `.${domainName}`,
      });
    },
    logout: (state) => {
      state.user = null;
      state.token = null;
      state.isAuthenticated = false;
      localStorage.removeItem("token");
    },
  },
});

export const { setCredentials, logout } = authSlice.actions;

export default authSlice.reducer;

// Selectors
export const selectCurrentUser = (state: { auth: AuthState }) =>
  state.auth.user;
export const selectIsAuthenticated = (state: { auth: AuthState }) =>
  state.auth.isAuthenticated;
export const selectToken = (state: { auth: AuthState }) => state.auth.token;
